<template>
  <div
    class="account-pane account-main"
    :class="{ active: active }"
    data-account-pane="main"
  >
    <div class="heading">
      <h3 class="greeting wt-sb font-lg">
        Hello, <span class="fg-primary">{{ user.name }}</span>
        <span class="fg-light-green">{{ user.company_name }}</span>
      </h3>

      <div class="links">
        <div class="link">
          <a href="/contact" class="button muted md white">
            <svg-icon id="chat"></svg-icon>
            <span>Contact us</span></a
          >
        </div>
        <template v-if="!$store.getters['user/stripeConnectIsOnboarded']">
          <div class="link">
            <span
              class="button loader-button md"
              @click="connectOnboardGo"
              :class="{ loading }"
              :disabled="loading"
            >
              <svg-icon id="stripe" v-if="loading == false"></svg-icon>
              <svg-icon
                id="loading"
                class="spin"
                v-if="loading == true"
              ></svg-icon
              ><span>Connect Stripe</span></span
            >
          </div>
        </template>
        <template v-else>
          <div class="link">
            <span class="button muted md" @click="addListing"
              ><svg-icon id="addBrief"></svg-icon
              ><span>Add a listing</span></span
            >
          </div>
        </template>
      </div>
    </div>
    <!-- /.heading -->

    <div class="account-nav-container">
      <internal-nav
        class="account-nav"
        :active-item="activeNavItem"
        :items="navItems"
        @select="changePage"
      ></internal-nav>
    </div>

    <div id="account-pages" class="account-content">
      <vue-simplebar class="account-pages container">
        <lister-listings-page></lister-listings-page>
        <bookings-page></bookings-page>
        <lister-account-details-page></lister-account-details-page>
      </vue-simplebar>
      <!-- /.account-pages -->
    </div>
    <!-- /.account-content -->

    <div class="pane-footer"></div>
    <!-- /.pane-footer -->
  </div>
</template>

<script>
import AccountPane from "../../AccountPane";
import ListerAccountDetailsPage from "./main/AccountDetails";
import BookingsPage from "../../shared/panels/main/Bookings";
import ListerListingsPage from "./main/Listings";

export default {
  extends: AccountPane,

  components: {
    ListerAccountDetailsPage,
    BookingsPage,
    ListerListingsPage,
  },

  data() {
    return {
      id: "main",
      page: "bookings",
      loading: false,
    };
  },

  computed: {
    activeNavItem() {
      return this.$store.getters["account/current"].page;
    },

    navItems() {
      return [
        { id: "listings", label: "Listings" },
        { id: "bookings", label: "Bookings" },
        // { id: "short-lists", label: "Short Lists" },
        { id: "account-details", label: "Account Details" },
        //{ id: 'notifications', label: 'Notifications', class: ['notice'] },
        // {id: 'activity-history',        label: 'Activity History'},
      ];
    },
  },

  methods: {
    connectOnboardGo() {
      this.loading = true;
      axios
        .get("/api/account/stripe-connect/account/onboard", {
          params: {
            redirect_to: this.redirectTo,
          },
        })
        .then((response) => {
          if (response.data.url) {
            this.loading = false;
            return window.open(response.data.url, "_blank").focus();
          }
          throw new Error("Invalid onboard link response");
        })
        .catch(() => {
          this.$toasted.show("Could not fetch Stripe connect onboard link", {
            type: "error",
          });
          this.loading = false;
        });
    },
    addListing() {
      if (!window.location.href.includes("#add-listing")) {
        window.history.pushState(
          "state obj or string",
          "url",
          window.location.href + "#add-listing"
        );
      }
      this.$store.dispatch("modals/showAddListing");
    },

    changePage(which) {
      this.$store.commit("account/navigateTo", {
        pane: this.id,
        page: which.id,
      });
    },
  },
};
</script>
